module.exports = __webpack_public_path__ + "img/spider-web.6c5e9b32.svg";